let activePreview: HTMLAudioElement | null = null;

/**
 * Starts playback in the same turn as the click. Waiting for canplaythrough
 * drops the user-gesture token and the browser blocks the sample.
 */
export function playVoicePreviewFromUserGesture(
  previewUrl: string,
  onFailure?: () => void,
): HTMLAudioElement | null {
  if (!previewUrl) return null;

  if (activePreview) {
    activePreview.pause();
    activePreview = null;
  }

  const audio = new Audio(previewUrl);
  activePreview = audio;
  const release = () => {
    if (activePreview === audio) activePreview = null;
  };
  audio.onended = release;
  audio.onerror = release;
  void audio.play().catch(() => {
    release();
    onFailure?.();
  });
  return audio;
}
